import React from "react";

const ResetFilterButton = ({ onReset }) => (
    <button
        type="button"
        onClick={onReset}
        className="reset-filter-gradient-bg px-5 py-2 me-2"
    >
        Reset Filters
    </button>
);

export default ResetFilterButton;